'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDestructuringPattern = isDestructuringPattern;
exports.matchesDestructuringPattern = matchesDestructuringPattern;
exports.isNonEmptyPattern = isNonEmptyPattern;
exports.matchesArrayPattern = matchesArrayPattern;
exports.matchesObjectPattern = matchesObjectPattern;
exports.toRestructureExpression = toRestructureExpression;
exports.toRestructureExpressionForArrayPattern = toRestructureExpressionForArrayPattern;
exports.toRestructureExpressionForObjectPattern = toRestructureExpressionForObjectPattern;
exports.accessors = accessors;

var _types = require('./types');

var _types2 = _interopRequireDefault(_types);

var _logical = require('./logical');

var _runtime = require('./runtime');

var _is = require('./is');

var _placeAtNode = require('ast-loc-utils/lib/placeAtNode');

var _placeAtNode2 = _interopRequireDefault(_placeAtNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Tools for dealing with destructuring patterns.

function isDestructuringPattern(node) {
  return node.type === "ArrayPattern" || node.type === "ObjectPattern";
}function matchesDestructuringPattern(ref, pattern) {
  var _it = pattern.type;
  if (_it === "ArrayPattern") {
    return matchesArrayPattern(ref, pattern);
  } else if (_it === "ObjectPattern") {
    return matchesObjectPattern(ref, pattern);
  }
}function isNonEmptyPattern(pattern) {
  var _it2 = pattern.type;
  if (_it2 === "ArrayPattern") {
    var _ref;

    return ((_ref = pattern.elements) == null ? null : _ref.length) > 0;
  } else if (_it2 === "ObjectPattern") {
    var _ref2;

    return ((_ref2 = pattern.properties) == null ? null : _ref2.length) > 0;
  }
} ////////// Array pattern matching
function Bracket(array, i, element) {
  return (0, _placeAtNode2.default)(_types2.default.memberExpression(array, (0, _placeAtNode2.default)(_types2.default.numericLiteral(i), element), true), element);
}function HasLength(array, min, max, patternNode) {
  return (0, _placeAtNode2.default)(_types2.default.callExpression((0, _placeAtNode2.default)(_types2.default.clone((0, _runtime.runtime)('hasLength')), patternNode), function () {
    var _arr = [array, (0, _placeAtNode2.default)(_types2.default.numericLiteral(min), patternNode)];

    if (max != null) _arr.push((0, _placeAtNode2.default)(_types2.default.numericLiteral(max), patternNode));
    return _arr;
  }()), patternNode);
}function matchesArrayPattern(array, arrayPattern) {
  var elements = arrayPattern.elements;

  // Determine min/max length of acceptable array
  var len = elements.length;
  var minLength = 0;
  var maxLength = len && elements[len - 1].type === "RestElement" ? null : len;
  for (var _i6 = elements.length - 1; _i6 >= 0; _i6--) {
    if (elements[_i6].type !== "AssignmentPattern" && elements[_i6].type !== "RestElement") {
      minLength = _i6 + 1;break;
    }
  }return (0, _logical.createAndExpression)(function () {
    var _arr2 = [HasLength(array, minLength, maxLength, arrayPattern)];

    for (var _i7 = 0, _len8 = elements.length; _i7 < _len8; _i7++) {
      var _element = elements[_i7];
      if (_element && isDestructuringPattern(_element)) {
        _arr2.push(matchesDestructuringPattern(Bracket(array, _i7, _element), _element));
      }
    }return _arr2;
  }());
} ////////// Object pattern matching
function In(key, obj) {
  return (0, _placeAtNode2.default)(_types2.default.binaryExpression('in', (0, _placeAtNode2.default)(_types2.default.stringLiteral(key.name), key), obj), key);
}function Dot(obj, key) {
  return (0, _placeAtNode2.default)(_types2.default.memberExpression(obj, key), key);
}function HasProps(obj, patternNode, props) {
  return (0, _placeAtNode2.default)(_types2.default.callExpression((0, _placeAtNode2.default)(_types2.default.clone((0, _runtime.runtime)('hasProps')), patternNode), [obj].concat(_toConsumableArray(props))), patternNode);
}function matchesObjectPattern(obj, objectPattern) {
  var properties = objectPattern.properties;

  return (0, _logical.createAndExpression)(function () {
    var _arr3 = [
    // _hasProps(_obj, ...)
    HasProps(obj, objectPattern, function () {
      var _arr4 = [];
      for (var _i8 = 0, _len9 = properties.length; _i8 < _len9; _i8++) {
        var _property = properties[_i8];
        if ((0, _is.isa)(_property, "ObjectProperty")) {
          var _key = _property.key,
              _value = _property.value;

          if (!(0, _is.isa)(_value, "AssignmentPattern") && (0, _is.isa)(_key, "Identifier")) {
            _arr4.push((0, _placeAtNode2.default)(_types2.default.stringLiteral(_key.name), _key));
          }
        }
      }return _arr4;
    }())

    // Conditions for nested patterns.
    // Destructuring patterns get a nested match. Defaulted items get a nested match
    // only if a default is not present.
    ];for (var _i9 = 0, _len10 = properties.length; _i9 < _len10; _i9++) {
      var _property2 = properties[_i9];
      if ((0, _is.isa)(_property2, "ObjectProperty")) {
        var _key2 = _property2.key,
            _value2 = _property2.value;

        if (_value2.type === "AssignmentPattern" && isDestructuringPattern(_value2.left)) {
          var _type = _value2.type,
              _left = _value2.left;

          _arr3.push((0, _logical.createOrExpression)((0, _logical.createNotExpression)(In(_key2, obj)), matchesDestructuringPattern(Dot(obj, _key2), _left)));
        } else if (isDestructuringPattern(_value2)) {
          _arr3.push(matchesDestructuringPattern(Dot(obj, _key2), _value2));
        }
      }
    }return _arr3;
  }());
} ////////// "Restructuring" after a destructure
function toRestructureExpression(pattern) {
  var _it3 = pattern.type;
  if (_it3 === "ArrayPattern") {
    return toRestructureExpressionForArrayPattern(pattern);
  } else if (_it3 === "ObjectPattern") {
    return toRestructureExpressionForObjectPattern(pattern);
  }
}function maybeToRestructureExpression(node) {
  if (isDestructuringPattern(node)) return toRestructureExpression(node);else return node;
}function toRestructureExpressionForArrayPattern(pattern) {
  return (0, _placeAtNode2.default)(_types2.default.arrayExpression(function () {
    var _arr5 = [];for (var _arr11 = pattern.elements, _i10 = 0, _len11 = _arr11.length; _i10 < _len11; _i10++) {
      var _element2 = _arr11[_i10];
      if ((0, _is.isa)(_element2, "AssignmentPattern")) {
        _arr5.push(maybeToRestructureExpression(_element2.left));
      } else if ((0, _is.isa)(_element2, "RestElement")) {
        _arr5.push((0, _placeAtNode2.default)(_types2.default.spreadElement(_element2.argument), _element2));
      } else {
        _arr5.push(maybeToRestructureExpression(_element2));
      }
    }return _arr5;
  }()), pattern);
}function restructureObjAssignment(assign, defaultKey) {
  if (isDestructuringPattern(assign.left)) {
    return _types2.default.objectProperty(defaultKey, toRestructureExpression(assign.left));
  } else {
    return _types2.default.objectProperty(assign.left, assign.left, false, true);
  }
}function toRestructureExpressionForObjectPattern(pattern) {
  return (0, _placeAtNode2.default)(_types2.default.objectExpression(function () {
    var _arr7 = [];for (var _arr12 = pattern.properties, _i11 = 0, _len12 = _arr12.length; _i11 < _len12; _i11++) {
      var _property3 = _arr12[_i11];
      if ((0, _is.isa)(_property3, "RestProperty")) {
        _arr7.push((0, _placeAtNode2.default)(_types2.default.spreadProperty(_property3.argument), _property3));
      } else if (isDestructuringPattern(_property3.value)) {
        var _key3 = _property3.key,
            _value3 = _property3.value;

        _arr7.push((0, _placeAtNode2.default)(_types2.default.objectProperty(_key3, toRestructureExpression(_value3)), _property3));
      } else if ((0, _is.isa)(_property3.value, "AssignmentPattern")) {
        var _key4 = _property3.key,
            _value4 = _property3.value;

        _arr7.push((0, _placeAtNode2.default)(restructureObjAssignment(_value4, _key4), _property3));
      } else if ((0, _is.isa)(_property3.value, "Identifier")) {
        var _value5 = _property3.value;

        _arr7.push((0, _placeAtNode2.default)(_types2.default.objectProperty(_value5, _value5, false, true), _property3));
      }
    }return _arr7;
  }()), pattern);
} ////////// Generate accessor expressions for destructuring patterns
function accessors(node, nodeAccessor, accum) {
  if ((0, _is.isa)(node, "Identifier")) {
    return accum[node.name] = nodeAccessor;
  } else if ((0, _is.isa)(node, "ArrayPattern")) {
    return accessorsForArrayPattern(node, nodeAccessor, accum);
  } else if ((0, _is.isa)(node, "ObjectPattern")) {
    return accessorsForObjectPattern(node, nodeAccessor, accum);
  } else if ((0, _is.isa)(node, "AssignmentPattern")) {
    return accessors(node.left, nodeAccessor, accum);
  }
}function accessorsForArrayPattern(pattern, accessor, accum) {
  for (var _arr13 = pattern.elements, _i12 = 0, _len13 = _arr13.length; _i12 < _len13; _i12++) {
    var _element3 = _arr13[_i12];
    accessors(_element3, _types2.default.memberExpression(accessor, _types2.default.numericLiteral(_i12), true), accum);
  }
}function accessorsForObjectPattern(pattern, accessor, accum) {
  for (var _arr14 = pattern.properties, _i13 = 0, _len14 = _arr14.length; _i13 < _len14; _i13++) {
    var _arr14$_i = _arr14[_i13],
        _key5 = _arr14$_i.key,
        _value6 = _arr14$_i.value;

    if ((0, _is.isa)(_key5, "Identifier")) {
      accessors(_value6, _types2.default.memberExpression(accessor, _key5), accum);
    }
  }
}